import React from 'react'
import { Route } from 'react-router'
import Import from '@/modules/import/data-import.component'

const importRoutes = (
  <>
    <Route path='import' Component={Import} />
  </>
)

export default importRoutes
